<template>
  <div>
    <div v-for="field in fields" :key="field.name">
      <sc-sysnode-commons 
        v-if="field.type === 'sysnode_commons'" 
        :value="value" 
        :warehouseId="warehouseId" 
        ref="sysnodeCommonsRef"/>
    </div>
  </div>
</template>

<script>
import {
  ScButton,
  ScToast,
} from '@intelipost-js/secure-components';
import ScSysnodeCommons from './ScSysnodeCommons';

export default {
  name: 'sc-sysnode-form',
  components: {
    ScButton,
    ScToast,
    ScSysnodeCommons,
  },
  props: {
    fields: {
      type: Array,
      required: true,
    },
    value: {
      type: Object,
      required: false,
    },
    warehouseId: {
      type: Number,
      required: false,
    },
  },
  methods: {
    validateConfig() {
      if (this.$refs.sysnodeCommonsRef.some(instance => !instance.validateConfig())) {
        return false;
      }
      return true;
    },
  },
};
</script>
<style lang="scss" scoped>
 .btn-validation {
  margin-top: 10px;
 }
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/components/sysnode/ScSysnodeForm.vue?1ee6c772